<template>
    <el-dialog title="排车调度"
               :visible="quickCancellationVisiable"
               :close-on-click-modal="false"
               :before-close="handleClose"
               :append-to-body='appendToBody'
               width="500px"
               v-dialogDrag>
        <el-form label-position="left"
                 :model="formData"
                 :rules="rules"
                 label-width="50px"
                 ref="formData"
                 class="rowIndex">
            <el-form-item label="车型"
                          prop="equipmentType"
                          class="label-form">
                <selects :optionNum="'TMS_CAR_TYPE'"
                         filterable
                         :mValue="formData.equipmentType"
                         @getSelectValue="getSelectValue"
                         placeholder="请选择车型"
                         :prop="'equipmentType'"></selects>
            </el-form-item>
        </el-form>
        <div slot="footer">
            <el-button @click="handleClose">取 消</el-button>
            <el-button type="primary"
                       :loading="saveLoading"
                       @click="handleSave()">保 存</el-button>
        </div>
    </el-dialog>
</template>
<script>
import selects from '@/components/lots/otpSelect';
import { dictWithUrl } from '@/components/lots/api.js';

export default {
    components: { selects },
    props: {
        quickCancellationVisiable: {
            type: Boolean,
            default: false
        },
        taskDataList: {
            type: Array,
            default () {
                return []
            }
        },
        appendToBody: {
            type: Boolean,
            default: false
        },
        flag: {
            type: String,
            default: '1'
        }
    },
    data () {
        return {
            formData: {
                equipmentName: '', // 车型
                equipmentType: '', // 车型编码
                preDispatchStrategy: 'FMCG', // 快消排车标识
                vehicleCard: '*',// 后端要求默认传参
                carrierCode: this.taskDataList.length > 0 ? this.taskDataList[0].carrierCode : '',
                carrierName: this.taskDataList.length > 0 ? this.taskDataList[0].carrierName : '',
                dispatchChannel: 'QCO'
            },
            saveLoading: false,
            rules: {
                equipmentType: [{ required: true, message: '车型必填', trigger: ['change'] }]
            },
            TMS_CAR_TYPE: ''
        };
    },
    methods: {
        // 数据字典
        getSelectValue (data) {
            this.formData = { ...this.formData, ...data };
        },
        handleClose () {
            this.$emit('update:quickCancellationVisiable', false);
        },
        handleSave () {
            this.$refs.formData.validate((valid) => {
                if (!valid) return false;
                this.saveLoading = true;
                this.formData.equipmentName = this.TMS_CAR_TYPE[this.formData.equipmentType];
                if (+this.flag === 2) { // 转移新建
                    this.formData.dispatchStatus = 6; // 发车单状态
                }
                this.saveLoading = false;
                this.$emit('AdmittOk', { state: true, data: this.formData });
                return false;
            });
        }
    },
    async mounted () {
        const dic = await dictWithUrl('TMS_CAR_TYPE');
        if (dic && +dic.code === 0) {
            this.TMS_CAR_TYPE = dic.data.TMS_CAR_TYPE;
        }
    }
};
</script>
